<template>
  <div>
    <header-applis titre="Connaître votre projet" sous-titre="Vous êtes dans une autre situation" index-progression-courante="1"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Nous vous invitons à identifier votre opérateur Conseil en Évolution Professionnelle (CEP) : <a href="https://www.mon-cep.org/" target="_blank">www.mon-cep.org</a>, et à
            prendre contact avec lui pour échanger à propos de votre projet.</p>
        </li>
        <li>
          <p>Une fois votre orientation finalisée, nous vous invitons à reprendre la démarche engagée, nous pourrons alors donner suite à votre demande.</p>
        </li>
      </ul>
      <envoyer-recapitulatif/>
    </div>
    <footer-applis ecran-precedent="choixstatut"/>
  </div>
</template>

<script>
import EnvoyerRecapitulatif from '../../components/EnvoyerRecapitulatif';
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'autresituation',
  components: {
    FooterApplis,
    HeaderApplis,
    EnvoyerRecapitulatif
  }
}
</script>
